import { useState } from 'react';
import type { SessionStorageValue } from '@/shared/lib/storage';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

type OverrideValue = SessionStorageValue<'debug-prefectural-grants-override'>;

/**
 * 都道府県補助金マッチングの利用可能状態オーバーライドを管理するフック
 * セッションストレージに状態を保存
 */
export const usePrefecturalGrantsOverride = () => {
  const [overrideValue, setOverrideValue] = useState<OverrideValue>(() =>
    getSessionStorage('debug-prefectural-grants-override'),
  );

  const updateOverrideValue = (value: OverrideValue) => {
    setOverrideValue(value);
    setSessionStorage('debug-prefectural-grants-override', value);
  };

  return {
    overrideValue,
    updateOverrideValue,
  };
};
